import { Box, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useCheckIfMasterPasswordExist, useCheckInCredential } from 'hooks'
import { EidButton, useNotification } from 'packages/eid-ui'
import { Icon } from 'packages/eid-icons'

const CheckIn = ({ data, drawerView, label }) => {
    const item = data?.resource

    const theme = useTheme()

    const { t } = useTranslation()
    const [
        checkInCredential,
        { isLoading: isCheckingIn },
    ] = useCheckInCredential(item.id)
    const { showWarningMessage } = useNotification()

    const { masterPasswordExists } = useCheckIfMasterPasswordExist()
    const handleCheckIn = () => {
        if (!masterPasswordExists()) {
            showWarningMessage(t('MasterPasswordDoesNotExist'))
            return
        }
        checkInCredential(item.checkOutId)
    }

    return (
        <>
            {!drawerView ? (
                <Box style={{ height: '24px' }}>
                    <EidButton.CheckInListing
                        loading={isCheckingIn}
                        label={label ? label : t('CheckIn')}
                        disabled={!item.canCheckIn}
                        onClick={handleCheckIn}
                    />
                </Box>
            ) : (
                <Box minWidth="167px">
                    <EidButton.DrawerActionButton
                        fontColor={theme?.palette?.common?.white}
                        bgColor={theme?.palette?.primary?.main}
                        width="100%"
                        disabled={!item.canCheckIn}
                        onClick={handleCheckIn}
                        loading={isCheckingIn}
                    >
                        <Box display="flex" alignItems="center">
                            <Icon
                                name="CheckOut"
                                color={theme?.palette?.common?.white}
                                direction={'right'}
                            />
                        </Box>
                        <Box
                            display="flex"
                            alignItems="center"
                            marginLeft="10px"
                        >
                            <Typography
                                style={{ color: theme?.palette?.common?.white }}
                            >
                                {t('CheckIn')}
                            </Typography>
                        </Box>
                    </EidButton.DrawerActionButton>
                </Box>
            )}
        </>
    )
}

CheckIn.defaultProps = {
    drawerView: false,
}

export default CheckIn
